<section class="our-loving-clients ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Our Valuable Clients</h2>
        </div>
        <div class="clients-logo-list align-items-center justify-content-center">
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay=".2s">
                <a href="https://avisdevelopers.com/" target="_blank">
                    <img src="assets/img/clients-image/AvisDevelopers.svg" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay=".4s">
                <a href="https://milangroupindia.com/" target="_blank">
                    <img src="assets/img/clients-image/Milan.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay=".6s">
                <a href="javascript:void(0)">
                    <img src="assets/img/clients-image/ssa-logo.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay=".8s">
                <a href="javascript:void(0)">
                    <img src="assets/img/clients-image/arpcc.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="1s">
                <a href="https://www.sohivacations.ca/" target="_blank">
                    <img src="assets/img/clients-image/SohiVacations.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="1.2s">
                <!-- http://www.zahraivf.com/ -->
                <a href="#" target="_blank">
                    <img src="assets/img/clients-image/ZahraIVF.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="1.4s">
                <a href="https://tajpark.ca/" target="_blank">
                    <img src="assets/img/clients-image/TajPark.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="1.6s">
                <a href="https://marutiimaging.com/" target="_blank">
                    <img src="assets/img/clients-image/MarutiImaging.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="1.8s">
                <a href="https://foreignfoods.in/" target="_blank">
                    <img src="assets/img/clients-image/ForeignFoods.jpg" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="2s">
                <a href="https://maariyaimpex.com/" target="_blank">
                    <img src="assets/img/clients-image/MaariyaImpex.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="2.2s">
                <a href="https://blissclinic.in/" target="_blank">
                    <img src="assets/img/clients-image/Bliss-Clinic.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="2.4s">
                <a href="#" target="_blank">
                    <img src="assets/img/clients-image/sustainablesmartwear.jpg" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="2.6s">
                <a href="https://zahraenterprise.kaimsit.com/" target="_blank">
                    <img src="assets/img/clients-image/ZahraEnterprise.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow animate__animated animate__fadeInUp" data-wow-delay="3s">
                <a href="https://vakilfoods.com/" target="_blank">
                    <img src="assets/img/clients-image/vakilFoods.jpg" alt="image">
                </a>
            </div>
        </div>
    </div>
</section>